import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterZSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLetterZSquare"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M8.875 16.2275V15.4775L13.6621 8.81543V8.72168H9.03906V7.77246H15.0273V8.52246L10.2637 15.1846V15.2783H15.127V16.2275H8.875Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterZSquare;
